import React from "react";
import { Box } from "@mui/material";
import { getAgentConfigSectionDomId } from "./navSectionUtils";

export default function AgentConfigSection({ id, children, sx }) {
  return (
    <Box
      id={getAgentConfigSectionDomId(id)}
      sx={{ scrollMarginTop: 16, ...sx }}
    >
      {children}
    </Box>
  );
}
